import {FC, SyntheticEvent} from 'react';

import {useQuantityPicker} from 'hooks/useQuantityPicker';

import FloatingQuantityPicker from './FloatingQuantityPicker';

const preventDefault = (e: SyntheticEvent) => {
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};

type QuantityPickerProps = {
  disabled: boolean;
  initialValue: number;
  max: number;
  onIncrement: (e: SyntheticEvent) => void;
  onDecrement: (e: SyntheticEvent) => void;
  onChange: (quantity: number, actionType: string) => Promise<boolean>;
  productId?: string;
  showKg?: boolean;
  moq?: number;
  isPDP?: boolean;
  isFavList?: boolean;
  isAddToCart?: boolean;
  enablePartialQuantity?: boolean;
  restrictDeleteFunctionality?: boolean;
  onDelete?: () => void;
  size: 'mini' | 'small' | 'medium' | 'large';
};

export const FloatingQuantityPickerWrapper: FC<QuantityPickerProps> = (props) => {
  const {
    formattedValue,
    minimumQuantity,
    maximumQuantity,
    handleDelete,
    handleDecrement,
    handleDecrementMouseDown,
    handleMouseUp,
    handleDecrementMouseLeave,
    handleContextMenu,
    handleIncrement,
    handleIncrementMouseDown,
    handleIncrementMouseLeave
  } = useQuantityPicker(props);

  return (
    <FloatingQuantityPicker
      count={formattedValue}
      handleDelete={handleDelete}
      handleDecrement={handleDecrement}
      handleDecrementMouseDown={handleDecrementMouseDown}
      handleMouseUp={handleMouseUp}
      handleDecrementMouseLeave={handleDecrementMouseLeave}
      handleContextMenu={handleContextMenu}
      handleIncrement={handleIncrement}
      handleIncrementMouseDown={handleIncrementMouseDown}
      handleIncrementMouseLeave={handleIncrementMouseLeave}
      min={minimumQuantity}
      max={maximumQuantity}
      preventDefault={preventDefault}
      size={props.size}
    />
  );
};
